import { useSearchParams } from 'react-router';
import {
  Box,
  Button,
  Icon,
  Image,
  Text,
  useBreakpointProp,
} from '@betty/moonlight';
import { TypographyNames } from '@betty/moonlight/lib/common/Text/Text.types';
import { useCallback } from 'react';
import {
  BETTY_COM_MS_CLICK_ID,
  BETTY_COM_REGISTER_URL,
  BETTY_COM_UTM_VARIANT,
  REDIRECT_SUGGESTION_BETTY_ONTARIO_SELECTED_SESSION_STORAGE_KEY,
} from '../../../hooks/useRedirectSuggestion.web';
import { Modal } from '@betty/navigation';
import { AsyncStorage } from '@betty/toolkit/storage';

function RedirectSuggestionModal() {
  const [searchParams] = useSearchParams();

  const redirectTitleTextVariant = useBreakpointProp<TypographyNames>({
    mobile: 'h4',
    tablet: 'h2',
    desktop: 'h2',
  });

  const redirectDescriptionTextVariant = useBreakpointProp<TypographyNames>({
    mobile: 'body-m',
    tablet: 'body-l',
    desktop: 'body-l',
  });

  const onStayOnBettyOntario = useCallback(() => {
    AsyncStorage.setItem(
      REDIRECT_SUGGESTION_BETTY_ONTARIO_SELECTED_SESSION_STORAGE_KEY,
      'true',
    );

    Modal.close();
  }, []);

  const onRedirectToBettyGlobal = useCallback(() => {
    const clickIdQueryParam = searchParams.get(BETTY_COM_MS_CLICK_ID);
    const redirectURL = clickIdQueryParam
      ? `${BETTY_COM_REGISTER_URL}?utm_variant=${BETTY_COM_UTM_VARIANT}&${BETTY_COM_MS_CLICK_ID}=${clickIdQueryParam}`
      : `${BETTY_COM_REGISTER_URL}?utm_variant=${BETTY_COM_UTM_VARIANT}`;

    window.location.href = redirectURL;
  }, [searchParams]);

  return (
    <Box
      flex={1}
      variant="outline-gradient"
      padding="space-800"
      gap="space-500"
      gradient="borderAccent"
      borderWidth="border-width-025"
      borderRadius="radius-400"
    >
      <Image
        name="registration.ontarioCanadaMap"
        width={152}
        height={110}
        alignSelf="center"
      />
      <Text
        variant={redirectTitleTextVariant}
        locNS="registration"
        locKey="redirectSuggestionModalTitle"
        color="darkSurfacePrimary"
        textAlign="center"
      />
      <Text
        variant={redirectDescriptionTextVariant}
        locNS="registration"
        locKey="redirectSuggestionModalDescription"
        color="darkSurfacePrimary"
      />
      <Box flexDirection="row" gap="space-400" justifyContent="center">
        <Box flexDirection="row" alignItems="flex-end">
          <Icon
            name="bettyLogo"
            width={{
              desktop: 99,
              tablet: 99,
              mobile: 80,
            }}
            height="auto"
          />
          <Text
            variant="h6"
            locNS="registration"
            locKey="globalDomain"
            color="darkSurfacePrimary"
            marginBottom="space-100"
            paddingBottom="space-050"
          />
        </Box>
        <Box
          width="space-025"
          height="100%"
          borderWidth="border-width-025"
          borderColor="borderSecondary"
        />
        <Box flexDirection="row" alignItems="flex-end">
          <Icon
            name="bettyLogo"
            width={{
              desktop: 99,
              tablet: 99,
              mobile: 80,
            }}
            height="auto"
          />
          <Text
            variant="h6"
            locNS="registration"
            locKey="ontarioDomain"
            color="darkSurfacePrimary"
            marginBottom="space-100"
            paddingBottom="space-050"
          />
        </Box>
      </Box>
      <Box flexDirection="column" gap="space-400">
        <Button
          variant="primary"
          locNS="registration"
          locKey="redirectSuggestionModalBettyComCTA"
          color="darkSurfacePrimary"
          size="large"
          onPress={onRedirectToBettyGlobal}
        />
        <Button
          variant="secondary"
          locNS="registration"
          locKey="redirectSuggestionModalBettyCaCTA"
          color="darkSurfacePrimary"
          size="large"
          onPress={onStayOnBettyOntario}
        />
      </Box>
    </Box>
  );
}

export default RedirectSuggestionModal;
